export default __webpack_public_path__ + "static/media/enjoy-life-fren.505adbbd.jpeg";